import { defineMessages } from 'react-intl';

export const i18n: {
	filterByIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButtonTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearFilters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterByIcon: {
		id: 'quick-find-filters.filter-by-icon-label',
		defaultMessage: 'Filter by Icon',
		description:
			'Accessible label for the filter icon button in the Quick Find inline product filters bar, used to indicate the purpose of the icon to screen readers.',
	},
	moreButtonTooltip: {
		id: 'inline-product-filters.more-filters.tooltip',
		defaultMessage: 'Open a full page search with more filter options for {product}',
		description:
			'Tooltip on the More button in Quick Find inline product filters bar. The placeholder {product} is replaced with the product name (e.g. Jira).',
	},
	clearFilters: {
		id: 'quick-find.filters.clear-filters-button-label',
		defaultMessage: 'Clear filters',
		description:
			'Button label to clear all active filters in the Quick Find inline product filters bar',
	},
});
